// Data extracted verbatim from MojumonCrimsonFixedStandalone.html (copy, order,
// Jin's facts, the 67-tamer roster (Sky removed 2026-09-10 at the team's request — her slot reused N3ku's sprite) with its alias + description tables and the
// role/style derivation the prototype ran at load time — precomputed here).

export type StarterId = "embrawl" | "driplett" | "wilting";
export type Starter = { id: StarterId; name: string; display: string; type: string; blurb: string; note: string; src: string };
export const STARTERS: Starter[] = [
  { id: "embrawl", name: "EMBRAWL", display: "Embrawl", type: "Blazing Fighter", blurb: "For Tamers who charge forward, trust their power, and never back down from a challenge.", note: "Direct and fearless. Best for Tamers who enjoy aggressive pressure and meeting challenges head-on.", src: "/mojumoncrimson/starters/embrawl.webp" },
  { id: "driplett", name: "DRIPLETT", display: "Driplett", type: "Water Wonder", blurb: "For Tamers who stay cool, adapt quickly, and turn a small opening into a winning play.", note: "Calm and adaptable. Best for Tamers who value flexibility and turning openings into advantages.", src: "/mojumoncrimson/starters/driplett.webp" },
  { id: "wilting", name: "WILTING", display: "Wilting", type: "Wild Growth", blurb: "For Tamers who play patiently, grow stronger, and surprise anyone who underestimates them.", note: "Patient and surprising. Best for Tamers who like clever growth and building toward greater power.", src: "/mojumoncrimson/starters/wilting.webp" },
];

export const JIN_FACTS: string[] = ["Captured Mojumon rest safely inside enchanted Scrolls.", "Every Mojumon specializes as an ATK, DEF, or SUPPORT partner.", "Radiant Mojumon are Legendary encounters—the rarest kind you can find.", "Each location has its own Mojumon and encounter rarities.", "Some Mojumon only reveal themselves during the day or at night.", "A balanced party is built from abilities that work together.", "Embrawl, Driplett, and Wilting are the three Crimson starters.", "The Crimson Squad steals Mojumon for illegal fusion experiments.", "Tigfu was forcibly created from Tigripere and Leofu.", "Want my starter notes? Click the journal in my hand—or press B."];

export const PARADE: { name: string; src: string }[] = [{"name": "Howlescent", "src": "/mojumoncrimson/parade/howlescent.webp"}, {"name": "Leofu", "src": "/mojumoncrimson/parade/leofu.webp"}, {"name": "NY Rat", "src": "/mojumoncrimson/parade/ny-rat.webp"}, {"name": "Toastee", "src": "/mojumoncrimson/parade/toastee.webp"}, {"name": "Tytogod", "src": "/mojumoncrimson/parade/tytogod.webp"}, {"name": "Telebit", "src": "/mojumoncrimson/parade/telebit.webp"}, {"name": "Akugu", "src": "/mojumoncrimson/parade/akugu.webp"}, {"name": "Chinobi", "src": "/mojumoncrimson/parade/chinobi.webp"}, {"name": "Defenguin", "src": "/mojumoncrimson/parade/defenguin.webp"}, {"name": "Elinxir", "src": "/mojumoncrimson/parade/elinxir.webp"}, {"name": "Fobius", "src": "/mojumoncrimson/parade/fobius.webp"}, {"name": "Gozio", "src": "/mojumoncrimson/parade/gozio.webp"}, {"name": "Fayth", "src": "/mojumoncrimson/parade/fayth.webp"}, {"name": "Lyria", "src": "/mojumoncrimson/parade/lyria.webp"}, {"name": "Cobrata", "src": "/mojumoncrimson/parade/cobrata.webp"}, {"name": "Cuarter", "src": "/mojumoncrimson/parade/cuarter.webp"}, {"name": "Iruphin", "src": "/mojumoncrimson/parade/iruphin.webp"}, {"name": "Lykosis", "src": "/mojumoncrimson/parade/lykosis.webp"}, {"name": "Nokturn", "src": "/mojumoncrimson/parade/nokturn.webp"}, {"name": "BitKnight", "src": "/mojumoncrimson/parade/bitknight.webp"}, {"name": "Reptail", "src": "/mojumoncrimson/parade/reptail.webp"}, {"name": "Malace", "src": "/mojumoncrimson/parade/malace.webp"}, {"name": "Rayvetus", "src": "/mojumoncrimson/parade/rayvetus.webp"}, {"name": "Tyto", "src": "/mojumoncrimson/parade/tyto.webp"}, {"name": "Simivi", "src": "/mojumoncrimson/parade/simivi.webp"}, {"name": "Tigripere", "src": "/mojumoncrimson/parade/tigripere.webp"}];

export type Tamer = { file: string; name: string; role: string; description: string };
export const TAMERS: Tamer[] = [
  {
    "file": "Senseicj",
    "name": "SenseiCJ",
    "role": "Sensei • Style 1",
    "description": "The Dojo's guide enters Crimson ready to lead new Tamers into their first great adventure."
  },
  {
    "file": "SenseiCJ2",
    "name": "SenseiCJ",
    "role": "Sensei • Style 2",
    "description": "SenseiCJ's alternate field look brings a sharper style to the same fearless leadership."
  },
  {
    "file": "Professor_Jin",
    "name": "Jin",
    "role": "Professor",
    "description": "The Voice of Reason trades the classroom for the field, guiding partners with calm strategy."
  },
  {
    "file": "ELITEFOUR_Craze",
    "name": "Craze",
    "role": "Elite Four",
    "description": "The Wu Warrior turns sharp instincts and relentless drive into an Elite Four challenge."
  },
  {
    "file": "ELITEFOUR_Leeann",
    "name": "Leeann",
    "role": "Elite Four",
    "description": "The Head of PR reads the room, controls the moment, and always keeps one surprise ready."
  },
  {
    "file": "ELITEFOUR_Rayrage",
    "name": "RayRage",
    "role": "Elite Four",
    "description": "The Angel King brings champion-level confidence and a commanding presence to every route."
  },
  {
    "file": "LEADER_Cami",
    "name": "Cami",
    "role": "Leader",
    "description": "A Crimson Leader with a poised look and the confidence to stand between Tamers and victory."
  },
  {
    "file": "LEADER_Dinero",
    "name": "Dinero",
    "role": "Leader",
    "description": "Ground Zero fights with explosive ambition, making every encounter feel like the main event."
  },
  {
    "file": "LEADER_Jas",
    "name": "Jas",
    "role": "Leader",
    "description": "The Judge studies every move and delivers decisive rulings when a battle reaches its limit."
  },
  {
    "file": "LEADER_Khay",
    "name": "Khay",
    "role": "Leader",
    "description": "A composed Leader whose field style suggests patience, precision, and a carefully built party."
  },
  {
    "file": "LEADER_Monae",
    "name": "Monae",
    "role": "Leader",
    "description": "A standout Leader who carries polished style and steady confidence into every challenge."
  },
  {
    "file": "LEADER_Nightscream",
    "name": "NightScream",
    "role": "Leader",
    "description": "A midnight-styled Leader who thrives under pressure and keeps rivals guessing after dark."
  },
  {
    "file": "LEADER_Nyne",
    "name": "Nyne",
    "role": "Leader",
    "description": "Mr. Lightshow brings spectacle, energy, and a bright presence to the Crimson League."
  },
  {
    "file": "LEADER_Queen",
    "name": "Queen",
    "role": "Leader",
    "description": "A royal Leader who commands the field with grace, authority, and unwavering standards."
  },
  {
    "file": "LEADER_Shadow",
    "name": "Shadow",
    "role": "Leader",
    "description": "The streaking Shoto brings speed, intensity, and a no-nonsense approach to every battle."
  },
  {
    "file": "LEADER_Sydnei",
    "name": "Sydnei",
    "role": "Leader",
    "description": "A confident Leader with an adventurous look built for long routes and major discoveries."
  },
  {
    "file": "TRAINER_Onidre",
    "name": "Onidre",
    "role": "Trainer",
    "description": "A determined Trainer beginning the journey with a practical look and something to prove."
  },
  {
    "file": "MOJUMONTAMER_Aurora",
    "name": "Aurora",
    "role": "Mojumon Tamer",
    "description": "A radiant Tamer whose calm field presence shines brightest when the route grows difficult."
  },
  {
    "file": "MOJUMONTAMER_Baja",
    "name": "Baja",
    "role": "Mojumon Tamer",
    "description": "A rugged Tamer ready for unpredictable encounters, rough terrain, and hard-earned victories."
  },
  {
    "file": "MOJUMONTAMER_Billy",
    "name": "Billy",
    "role": "Mojumon Tamer",
    "description": "An easygoing Tamer whose approachable style hides a team prepared for serious competition."
  },
  {
    "file": "MOJUMONTAMER_Birrrd",
    "name": "Birrrd",
    "role": "Mojumon Tamer",
    "description": "A high-energy Tamer who brings quick reactions and restless momentum to the field."
  },
  {
    "file": "MOJUMONTAMER_boobee",
    "name": "Boobee",
    "role": "Mojumon Tamer",
    "description": "A colorful Tamer with an unmistakable look and a playful approach to the Crimson journey."
  },
  {
    "file": "MOJUMONTAMER_botjedeye",
    "name": "Bot Jedeye",
    "role": "Mojumon Tamer",
    "description": "A focused strategist who scans every matchup and searches for the smartest path forward."
  },
  {
    "file": "MOJUMONTAMER_bryan",
    "name": "Bryan",
    "role": "Mojumon Tamer",
    "description": "A dependable Tamer built for exploration, teamwork, and the long road between towns."
  },
  {
    "file": "MOJUMONTAMER_C1",
    "name": "C1",
    "role": "Mojumon Tamer",
    "description": "A precise field operative who treats every encounter like a mission worth completing."
  },
  {
    "file": "MOJUMONTAMER_Cell",
    "name": "Cell",
    "role": "Mojumon Tamer",
    "description": "Samurai Cell carries disciplined focus, sharp instincts, and the pride of the Order of the Bow."
  },
  {
    "file": "MOJUMONTAMER_Chica",
    "name": "Chica",
    "role": "Mojumon Tamer",
    "description": "Cheeks brings bold personality and a fearless sense of fun to every new route."
  },
  {
    "file": "MOJUMONTAMER_Emmera",
    "name": "Emmera",
    "role": "Mojumon Tamer • Style 1",
    "description": "A versatile Tamer with several field styles, each giving the same journey a fresh identity."
  },
  {
    "file": "MOJUMONTAMER_Emmera_1",
    "name": "Emmera",
    "role": "Mojumon Tamer • Style 2",
    "description": "A versatile Tamer with several field styles, each giving the same journey a fresh identity."
  },
  {
    "file": "MOJUMONTAMER_Emmera_2",
    "name": "Emmera",
    "role": "Mojumon Tamer • Style 3",
    "description": "A versatile Tamer with several field styles, each giving the same journey a fresh identity."
  },
  {
    "file": "MOJUMONTAMER_Emmera_3",
    "name": "Emmera",
    "role": "Mojumon Tamer • Style 4",
    "description": "A versatile Tamer with several field styles, each giving the same journey a fresh identity."
  },
  {
    "file": "MOJUMONTAMER_Emmera_4",
    "name": "Emmera",
    "role": "Mojumon Tamer • Style 5",
    "description": "A versatile Tamer with several field styles, each giving the same journey a fresh identity."
  },
  {
    "file": "MOJUMONTAMER_Empath",
    "name": "Empath",
    "role": "Mojumon Tamer",
    "description": "An intuitive Tamer who reads partners closely and builds trust before chasing victory."
  },
  {
    "file": "MOJUMONTAMER_Geno",
    "name": "Geno",
    "role": "Mojumon Tamer",
    "description": "The Shogun of Cream arrives with veteran confidence and a larger-than-life battle presence."
  },
  {
    "file": "MOJUMONTAMER_Goji",
    "name": "Goji",
    "role": "Mojumon Tamer",
    "description": "A sturdy Tamer with the look of an explorer who is always ready for the next wild encounter."
  },
  {
    "file": "MOJUMONTAMER_GreenNovas",
    "name": "GreenNovas",
    "role": "Mojumon Tamer",
    "description": "A bright, determined Tamer whose adventurous spirit keeps the whole party moving forward."
  },
  {
    "file": "MOJUMONTAMER_henno",
    "name": "Henno",
    "role": "Mojumon Tamer",
    "description": "The Temple Treasurer brings careful planning and dependable judgment to every expedition."
  },
  {
    "file": "MOJUMONTAMER_Hooper",
    "name": "Hooper",
    "role": "Mojumon Tamer",
    "description": "A charismatic Tamer who keeps the mood light while preparing a party that can finish fights."
  },
  {
    "file": "MOJUMONTAMER_Infamous",
    "name": "Infamous",
    "role": "Mojumon Tamer",
    "description": "A mysterious Tamer whose reputation arrives before them on every Crimson route."
  },
  {
    "file": "MOJUMONTAMER_Jewel",
    "name": "Jewel",
    "role": "Mojumon Tamer",
    "description": "The Fleet Admiral commands the field with elite confidence and a history of major milestones."
  },
  {
    "file": "MOJUMONTAMER_Kaneka",
    "name": "Kaneka",
    "role": "Mojumon Tamer",
    "description": "A composed Tamer with a clean field style and the patience to develop a balanced team."
  },
  {
    "file": "MOJUMONTAMER_Kid",
    "name": "Kid",
    "role": "Mojumon Tamer",
    "description": "A dangerous competitor whose sharp look matches an aggressive, fearless battle style."
  },
  {
    "file": "MOJUMONTAMER_kount",
    "name": "Kount",
    "role": "Mojumon Tamer",
    "description": "A calculating Tamer who keeps track of every advantage and waits for the perfect opening."
  },
  {
    "file": "MOJUMONTAMER_Krisskross",
    "name": "Krisskross",
    "role": "Mojumon Tamer",
    "description": "A lively Tamer with unpredictable energy and a party designed to keep opponents off balance."
  },
  {
    "file": "MOJUMONTAMER_Leeann",
    "name": "Leeann",
    "role": "Mojumon Tamer",
    "description": "The Head of PR reads the room, controls the moment, and always keeps one surprise ready."
  },
  {
    "file": "MOJUMONTAMER_LVJ",
    "name": "LVJ",
    "role": "Mojumon Tamer",
    "description": "A cool-headed Tamer whose understated style lets strong choices and loyal partners speak loudest."
  },
  {
    "file": "MOJUMONTAMER_Mapleman",
    "name": "Maple Man",
    "role": "Mojumon Tamer",
    "description": "The Titan stands tall as a resilient Tamer built to weather pressure and protect the team."
  },
  {
    "file": "MOJUMONTAMER_moneymott",
    "name": "Money Mott",
    "role": "Mojumon Tamer",
    "description": "A polished Tamer who brings Keyblade Master confidence and premium style into the field."
  },
  {
    "file": "MOJUMONTAMER_Monkmaster",
    "name": "Monk Master",
    "role": "Mojumon Tamer",
    "description": "Monk Master balances body, mind, and spirit to bring discipline to every Mojumon partnership."
  },
  {
    "file": "MOJUMONTAMER_N3ku",
    "name": "N3ku",
    "role": "Mojumon Tamer",
    "description": "A modern Tamer with a sharp silhouette and the curiosity to explore every hidden corner."
  },
  {
    "file": "MOJUMONTAMER_Poogly",
    "name": "Poogly",
    "role": "Mojumon Tamer",
    "description": "A spirited Tamer with unmistakable charm, a big heart, and a surprising competitive streak."
  },
  {
    "file": "MOJUMONTAMER_Pushaman",
    "name": "Pushaman",
    "role": "Mojumon Tamer",
    "description": "Pusha brings strong personality, quick instincts, and a firm plan for keeping trouble away."
  },
  {
    "file": "MOJUMONTAMER_Pushplay",
    "name": "Pushplay",
    "role": "Mojumon Tamer",
    "description": "An energetic Tamer who treats each battle like the moment to press forward and take control."
  },
  {
    "file": "MOJUMONTAMER_Rea",
    "name": "Rea",
    "role": "Mojumon Tamer",
    "description": "A Duelist-minded Tamer whose focused stance promises direct, confident challenges."
  },
  {
    "file": "MOJUMONTAMER_Sage",
    "name": "Sage",
    "role": "Mojumon Tamer • Style 1",
    "description": "A versatile Tamer with multiple outfits and a thoughtful approach to mastering the journey."
  },
  {
    "file": "MOJUMONTAMER_Sage_1",
    "name": "Sage",
    "role": "Mojumon Tamer • Style 2",
    "description": "A versatile Tamer with multiple outfits and a thoughtful approach to mastering the journey."
  },
  {
    "file": "MOJUMONTAMER_Sage_2",
    "name": "Sage",
    "role": "Mojumon Tamer • Style 3",
    "description": "A versatile Tamer with multiple outfits and a thoughtful approach to mastering the journey."
  },
  {
    "file": "MOJUMONTAMER_Sage_3",
    "name": "Sage",
    "role": "Mojumon Tamer • Style 4",
    "description": "A versatile Tamer with multiple outfits and a thoughtful approach to mastering the journey."
  },
  {
    "file": "MOJUMONTAMER_Sage_4",
    "name": "Sage",
    "role": "Mojumon Tamer • Style 5",
    "description": "A versatile Tamer with multiple outfits and a thoughtful approach to mastering the journey."
  },
  {
    "file": "MOJUMONTAMER_Sauce",
    "name": "Sauce",
    "role": "Mojumon Tamer",
    "description": "The Card Boss brings clever reads, risky plays, and the confidence to bet on the perfect partner."
  },
  {
    "file": "MOJUMONTAMER_Supremacy",
    "name": "Supremacy",
    "role": "Mojumon Tamer",
    "description": "A commanding Tamer who enters every route expecting to set the pace and own the field."
  },
  {
    "file": "MOJUMONTAMER_swag",
    "name": "Swag",
    "role": "Mojumon Tamer",
    "description": "A stylish Tamer who proves that personality and presentation can travel with real battle skill."
  },
  {
    "file": "MOJUMONTAMER_tash",
    "name": "Tash",
    "role": "Mojumon Tamer",
    "description": "A fierce Tamer whose strong presence signals courage, discipline, and readiness for any rival."
  },
  {
    "file": "MOJUMONTAMER_Toekage",
    "name": "ToeKage",
    "role": "Mojumon Tamer",
    "description": "The Slayer moves with quiet purpose, carrying a battle-ready look into dangerous territory."
  },
  {
    "file": "MOJUMONTAMER_Turts",
    "name": "Turts",
    "role": "Mojumon Tamer",
    "description": "A steady Tamer who favors patience, toughness, and partners that can endure the long game."
  },
  {
    "file": "MOJUMONTAMER_Wramm",
    "name": "Wramm",
    "role": "Mojumon Tamer",
    "description": "A powerhouse Tamer whose imposing style suggests a direct path through every obstacle."
  },
  {
    "file": "MOJUMONTAMER_X",
    "name": "X",
    "role": "Mojumon Tamer",
    "description": "An enigmatic Tamer with a stripped-down identity, leaving rivals to discover the rest in battle."
  }
];
export const tamerSrc = (t: Tamer) => `/mojumoncrimson/tamers/${t.file}.webp`;

export type FusionCase = { code: string; label: string; left: { name: string; src: string; alt: string }; right: { name: string; src: string; alt: string }; result: { name: string; src: string; alt: string }; text: string };
export const FUSIONS: FusionCase[] = [
  { code: "Case 01 // Forced Fusion", label: "Tigfu forced fusion record",
    left: { name: "Tigripere", src: "/mojumoncrimson/parade/tigripere.webp", alt: "16-bit Tigripere leaping" },
    right: { name: "Leofu", src: "/mojumoncrimson/fusion/leofu-crouch.webp", alt: "16-bit Leofu crouching" },
    result: { name: "Tigfu", src: "/mojumoncrimson/fusion/tigfu.webp", alt: "16-bit Tigfu in a fierce pouncing pose" },
    text: "Two stolen feline Mojumon forcibly merged into one defiant fighter." },
  { code: "Case 02 // Forced Fusion", label: "Semto forced fusion record",
    left: { name: "Simivi", src: "/mojumoncrimson/parade/simivi.webp", alt: "16-bit Simivi with exactly two arms" },
    right: { name: "Tyto", src: "/mojumoncrimson/parade/tyto.webp", alt: "16-bit Tyto flying with wings spread" },
    result: { name: "Semto", src: "/mojumoncrimson/fusion/semto.webp", alt: "16-bit Semto with exactly two arms and two large hands" },
    text: "A meditative Mojumon and a watchful flier forced into one unstable guardian." },
];

export const ART = { professor: "/mojumoncrimson/professor-jin.webp", heroes: "/mojumoncrimson/heroes.webp", threat: "/mojumoncrimson/rush-roulette.webp" };
